import { Pagination } from '../../../models/pagination.model';
import { CourseCategory, CourseItem } from './models';

export interface CoursesState {
  courseItems: CourseItem[];
  pagination: Pagination;
  categories: CourseCategory[] | null;
  selectedCourseItem: CourseItem | null;
  createdCourseItem: CourseItem | null;
  isSyncingContents: boolean;
  isSyncSuccess: boolean;
  enrolledCourses: CourseItem[];
}

export const initialState: CoursesState = {
  courseItems: [],
  categories: null,
  pagination: {
    totalDocs: 0,
    limit: 0,
    totalPages: 0,
    page: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: 0,
    nextPage: 0,
  },
  selectedCourseItem: null,
  createdCourseItem: null,
  isSyncingContents: false,
  isSyncSuccess: false,
  enrolledCourses: [],
};
